import React from 'react'
import { Spinner } from 'react-bootstrap'

const LoaderIndicator = () => {
    return (
        <Spinner size="md" animation="border" variant="dark" />
    )
}

export default LoaderIndicator